import { UserState } from './types';

export const INITIAL_STATE: UserState = {
  isDev: false,
  searchCounter: null,
  showBookmarksTooltip: null,
  bookmarksDiscovered: null,
  isShowFeed: true,
  installSource: null,
  viewedStories: [],
  activityCounter: 0,
  quickReload: 100,
  isInvited: null,
  loggedUser: {
    token: null,
    value: null,
    fetchedAt: null,
    isExtension: false,
  },
  shells: {
    dailyShellsCounter: 0,
    updatedAt: 0,
    increment: 0,
    boosters: 5,
    boosterUsed: false,
    // old
    counter: 0,
    // new
    shellsCounter: 0,

    trackingBufferPrev: 0,
    trackingBufferCurrent: 0,
  },
  onboarding: {
    startedAt: Date.now(),
    shells: 5,
    counter: 5,
    topSites: 5,
    customizeBg: 5,
    shellsAlgorithm: 0,
    counterFirstBottle: 5,
    socialFeed: 5,
    searchForm: process.env.APP_TYPE === 'lite' ? 5 : 0,
    lastTopSitesViewed: Date.now(),
  },
  experiment: {
    fetchedAt: Date.now(),
    value: {
      scenario: {
        featureFlags: {
          NEWS_ON: null,
          AD_TILES: null,
          CUSTOM_SEARCH_ENGINE: false,
          COLLECT_SHELLS_IN_GOOGLE_OFF: false,
          DIMINISHING_RETURNS: false,
          SURVEY_CHEST: false,
          GAMES_NEW_TITLE: true,

          ...(process.env.NODE_ENV === 'development' && {
            MAGIC_SEARCH_BOX: true,
          }),
        },
      },
    },
  },
  installationDate: Date.now(),
  lastTrackRetention: null,
  userId: null,
  settings: null,
  ntpVisitCounter: 0,
  ntpDayVisitCounter: 0,
  isGainedBottles: false,
  bookmarksNotificationHidden: process.env.APP_PLATFORM === 'web',
  googleAccounts: null,

  openedAt: null,
  previouslyOpenedAt: null,
  isFastReload: false,
  isFirstTimeToday: false,
  utmCampaign: null
};
